import type { ReactNode } from "react";

interface OptionCardProps {
  name: string;
  value: string;
  label: string;
  description?: string;
  icon?: ReactNode;
  checked: boolean;
  type?: "radio" | "checkbox";
  onChange: (checked: boolean) => void;
}

/**
 * A large, touch-friendly selectable card. Built on a real native
 * radio/checkbox input (visually hidden, not display:none) so keyboard
 * navigation, arrow-key grouping (for radios), and screen readers all get
 * standard browser behavior for free instead of reimplemented ARIA
 * widgets. The card itself is just the <label> styling around that input.
 */
export function OptionCard({ name, value, label, description, icon, checked, type = "radio", onChange }: OptionCardProps) {
  return (
    <label className={`option-card${checked ? " option-card--selected" : ""}`}>
      <input
        className="option-card__input"
        type={type}
        name={name}
        value={value}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="option-card__body">
        {icon ? (
          <span className="option-card__icon" aria-hidden="true">
            {icon}
          </span>
        ) : null}
        <span className="option-card__text">
          <span className="option-card__label">{label}</span>
          {description ? <span className="option-card__description">{description}</span> : null}
        </span>
      </span>
      <span className="option-card__check" aria-hidden="true" />
    </label>
  );
}
